import { api } from "@api/api";
import { PartnerReferral } from "@modules/partners/types";
import { ReferralFormValues } from "@modules/partners/validations";

export async function createReferralService(
  data: ReferralFormValues
): Promise<PartnerReferral> {
  const { data: referral } = await api.post<PartnerReferral>(
    "/v1/partner_referral_admin/",
    data
  );
  return referral;
}
